import { UPLOAD_MAX_SIZE_MB } from '../config';
import { formatFileSizeMb } from './formatQuota';

const VIDEO_EXTENSIONS = ['.mp4', '.mkv', '.mov', '.webm', '.flv', '.avi'];

/**
 * @param {File} file
 * @param {{ maxFileMb?: number }} [options] 账号档位上限（MB），不传则用环境硬顶
 */
export function validateVideoFile(file, options = {}) {
  if (!file) {
    return { ok: false, message: '未选择文件' };
  }
  const isVideo = file.type && file.type.startsWith('video/');
  const name = (file.name || '').toLowerCase();
  const hasKnownExt = VIDEO_EXTENSIONS.some(ext => name.endsWith(ext));
  if (!isVideo && !hasKnownExt) {
    return { ok: false, message: '请上传视频文件（MP4、MKV、MOV 等）' };
  }
  const maxMb = options.maxFileMb != null ? options.maxFileMb : UPLOAD_MAX_SIZE_MB;
  const maxLabel = formatFileSizeMb(maxMb);
  const sizeMb = file.size / 1024 / 1024;
  if (sizeMb > maxMb) {
    return { ok: false, message: `视频不能超过当前档位上限（${maxLabel}）` };
  }
  return { ok: true, message: '' };
}
